import { forwardRef, type InputHTMLAttributes, type ReactNode } from "react";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
  sizeVariant?: "md" | "lg";
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { iconLeft, iconRight, sizeVariant = "md", className = "", ...rest },
  ref,
) {
  const sizeClass = sizeVariant === "lg" ? "h-12 text-base" : "h-10 text-sm";
  const paddingLeft = iconLeft ? "pl-10" : "pl-3.5";
  const paddingRight = iconRight ? "pr-10" : "pr-3.5";
  return (
    <div className="relative">
      {iconLeft && (
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400 pointer-events-none">
          {iconLeft}
        </span>
      )}
      <input
        ref={ref}
        className={`w-full ${sizeClass} ${paddingLeft} ${paddingRight} rounded-lg border border-zinc-200 bg-white text-zinc-900 placeholder:text-zinc-400 transition-shadow hover:border-zinc-300 focus:border-ktm-orange focus:ring-2 focus:ring-ktm-orange-100 focus:outline-none disabled:bg-zinc-50 disabled:text-zinc-400 ${className}`}
        {...rest}
      />
      {iconRight && (
        <span className="absolute right-3 top-1/2 -translate-y-1/2 text-zinc-400">
          {iconRight}
        </span>
      )}
    </div>
  );
});
